import type { ProductPurchase } from 'react-native-iap';
import * as Linking from 'expo-linking';

import type {
  PurchaseUpdatedListenerType,
  IIAPService,
} from './IAPService';
import { subscriptionStoreURLs } from '@constants';

/**
 * Placeholder service for web
 */
class IAPService implements IIAPService {
  initConnection() {
    return Promise.resolve(false);
  }

  endConnection() {
    return Promise.resolve();
  }

  getSubscriptions(_skus: string[]) {
    return Promise.resolve([]);
  }

  getAllSubscriptions() {
    return Promise.resolve([]);
  }

  flushFailedPurchasesCachedAsPendingAndroid() {
    return Promise.resolve([]);
  }

  requestSubscription(
    _sku: string,
    _andDangerouslyFinishTransactionAutomaticallyIos?: any,
    _purchaseTokenAndroid?: any,
    // _prorationModeAndroid?: any,
    _obfuscatedAccountIdAndroid?: any,
    _obfuscatedProfileIdAndroid?: any,
  ): Promise<null> {
    return Promise.resolve(null);
  }

  finishTransaction(
    _purchase: ProductPurchase,
    _isConsumable?: boolean,
    _developerPayloadAndroid?: string,
  ) {
    return Promise.resolve();
  }

  addPurchaseUpdatedListener(
    _listener: PurchaseUpdatedListenerType,
  ) {}

  removePurchaseUpdatedListener() {}

  openAppleAppStore() {
    return Linking.openURL(subscriptionStoreURLs.APPLE_APP_STORE);
  }

  openGooglePlayStore(_: string) {
    return Linking.openURL(subscriptionStoreURLs.GOOGLE_PLAY_STORE);
  }
}

export default new IAPService();
